"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDimension = void 0;
/* eslint-disable prefer-destructuring */
const no_react_1 = require("remotion/no-react");
exports.validateDimension = no_react_1.NoReactInternals.validateDimension;
